
import { Route } from 'react-router-dom';
import TaskChartPage from 'src/screens/task-chart';
import { PrivateRoute } from 'src/screens/app/routes/user/user.utils';

const taskChartRouteGroup = (
  <Route path="task-chart">
    <Route index element={<PrivateRoute children={<TaskChartPage />} />} />
  </Route>
);

export default taskChartRouteGroup;